import Select, { components } from "react-select";

import { Check, ChevronBottom, X } from "../../Icons/general-interface-1";
import {
  control,
  clearIndicator,
  dropdownIndicator,
  indicatorSeparator,
  option,
  menu,
  menuList,
  placeholder,
  valueContainer,
} from "../commonStyles";
import commonStyles from "../index.module.scss";
import styles from "./index.module.scss";

type PropsType = {
  onChange: (status: { value: string; label: string }) => void;
  value?:{ value: unassignedType, label: string };
};

const ClearIndicator = ({ ...props }) => (
  <components.ClearIndicator {...props}>
    <X />
  </components.ClearIndicator>
);

const DropdownIndicator = ({ ...props }) => (
  <components.DropdownIndicator {...props}>
    <ChevronBottom />
  </components.DropdownIndicator>
);

const Option = (props) => (
  <components.Option {...props}>
    <div className={styles.optionLabel}>{props.data.label}</div>
    {props.isSelected && <Check className={styles.iconCheck} />}
  </components.Option>
);

const customStyles = {
  control,
  dropdownIndicator,
  clearIndicator,
  indicatorSeparator,
  option,
  menu,
  menuList,
  placeholder,
  valueContainer,
  singleValue: (provided) => ({
    ...provided,
    color: commonStyles.grey_500,
    fontFamily: commonStyles.font,
    fontSize: "16px",
  }),
};

export const unassignedList = [
  { value: "unassigned", label: "Unassigned" },
  { value: "assigned", label: "Assigned" },
] as const;

export type unassignedType = typeof unassignedList[number]["value"];

const UnassignedFilterDropdown = ({ onChange, value }: PropsType) => {
  const onDropdownSelect = (selection) => {
    onChange(selection);
  };

  return (
    <Select
      value={!value ? null : value}
      styles={customStyles}
      classNamePrefix="statusFilterDropdown"
      placeholder="Filter by assignment"
      onChange={onDropdownSelect}
      options={unassignedList}
      maxMenuHeight="197px"
      isSearchable={false}
      isClearable
      components={{
        DropdownIndicator,
        ClearIndicator,
        Option,
      }}
    />
  );
};

export default UnassignedFilterDropdown;
